<template>
      <div class="grid">
       <div class="grid-sizer "></div>
    <q-card  v-for="post in CardFilter" :key="post.id" class="grid-item">

           <q-img :src="post.img" :alt="post.title">
        <div class="text-h3 absolute-bottom text-center card-img">
          <h3>{{ post.title }}</h3>
        </div>
      </q-img>
    
      <q-card-section class="description">
        <div v-html=" post.description"></div>
      
      </q-card-section>
   <q-separator />

      <q-card-section>  

      <div class="tag-container">
      
          <div>
            
            <router-link  class="button is-large learn-more-btn" :to="{name: 'Activity', params: { id: post.id }, hash: '#two'}">Learn more</router-link>
          </div>
          <div class="tag-group">
            <span v-for="tag in post.tags" :key="tag"  @click="tagHandler(tag)" class="tag tag-spaceing is-large">{{tag.split("_").join(" ")}}</span>
        </div>

    

      
      </div>

      </q-card-section>

    
    </q-card>
  </div>
</template>

<script>
import {onMounted, ref, computed} from 'vue'
import { useRouter } from 'vue-router'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
export default {
    props: ['posts', 'tagSelection'],
    setup(props, {emit}) {

      

     
  onMounted(() => {
      var grid = document.querySelector('.grid');
      var msnry;

      imagesLoaded( grid, function() {
        // init Isotope after all images have loaded
        msnry = new Masonry( grid, {
        itemSelector: '.grid-item', 
        gutter: 20,
        // columnWidth: 100,
        isFitWidth: true
        });
      });

      return {msnry}
    })


    const CardFilter = computed(() => {

    const newPosts = [...props.posts]
    
    return newPosts.sort((a, b) => { 
    return a.title > b.title ? 1 : -1 
  })

      console.log()
        
    return {newPosts}
  })  

  
     const tagFilter = computed(() => {

    const newPosts = [...props.posts]
    
    return newPosts.sort((a, b) => { 
    return a.tags > b.tags ? 1 : -1 
  })

    return {newPosts}
      console.log()
        
  })  

      const router = useRouter()
      const tagHandler = (tag) => {

        // const newTag = JSON.stringify(tag.split(" ").join("_"))
        router.push({name: 'Tag', params: { tag }, hash: '#two'})
        var grid = document.querySelector('.grid');
        var msnry;
        imagesLoaded( grid, function() {
        // init Isotope after all images have loaded
        msnry = new Masonry( grid, {
        itemSelector: '.grid-item', 
        gutter: 20,
        // columnWidth: 100,
        isFitWidth: true
        });
      });

      return {msnry, newTag}
      }
      return { tagHandler, router, CardFilter, tagFilter }
    }

}
</script>

<style>

</style>